<template>
  <div
          style="width: 100%; height: 100%; background-color: #f4f4f5"
          class="qr-code-pay-div"
  >
    <div
            class="man-container"
            style="overflow-y: auto; height: calc(100% - 60px)"
    >
      <mobile-card style="font-size: 14px">
        <template slot="title">
          <div class="charge-card-title">人员信息</div>
        </template>

        <template slot="content">
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 28px">用户编号：</div>
            <div class="right">
              <span
                      style="
                  padding: 0px;
                  margin: 0px;
                  height: 100%;
                  line-height: 28px;
                  padding-right: 5px;
                "
              >{{ userInfo.userCode }}</span
              >
            </div>
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 28px">用户姓名：</div>
            <div class="right">
              <span
                      style="
                  padding: 0px;
                  margin: 0px;
                  height: 100%;
                  line-height: 28px;
                  padding-right: 5px;
                "
              >{{ userInfo.userName }}</span
              >
            </div>
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 28px">所属部门：</div>
            <div class="right">
              <span
                      style="
                  padding: 0px;
                  margin: 0px;
                  height: 100%;
                  line-height: 28px;
                  padding-right: 5px;
                "
              >{{ userInfo.deptNames ? userInfo.deptNames : "--" }}</span
              >
            </div>
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 28px">证件号码：</div>
            <div class="right">
              <span
                      style="
                  padding: 0px;
                  margin: 0px;
                  height: 100%;
                  line-height: 28px;
                  padding-right: 5px;
                "
              >{{ userInfo.idNum | normalMask }}</span
              >
            </div>
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 28px">手机号码：</div>
            <div class="right">
              <van-field
                      input-align="right"
                      label-align="left"
                      size="14px"
                      placeholder="请输入手机号码"
                      style="
                  padding: 0px;
                  margin: 0px;
                  height: 100%;
                  line-height: 28px;
                  padding-right: 5px;
                "
                      v-model="userInfo.tele"
                      right-icon="edit"
              />
            </div>
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 28px">电子邮箱：</div>
            <div class="right">
              <van-field
                      input-align="right"
                      label-align="left"
                      size="14px"
                      placeholder="请输入电子邮箱"
                      style="
                  padding: 0px;
                  margin: 0px;
                  height: 100%;
                  line-height: 28px;
                  padding-right: 5px;
                "
                      v-model="userInfo.email"
                      right-icon="edit"
              />
            </div>
          </div>
        </template>
      </mobile-card>

      <mobile-card style="font-size: 14px">
        <template slot="title">
          <div class="charge-card-title">银行卡信息</div>
        </template>
        <template slot="content">
          <div class="flex-form-info" style="height: auto">
            <div class="left">户名：</div>
            <div class="right">
              <van-field
                input-align="right"
                label-align="left"
                size="14px"
                placeholder="请输入户名"
                v-model="userInfo.bankAccountName"
                readonly
              />
            </div>
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 28px;width: 56px">卡号：</div>
            <div class="right" style="width: 320px">
              <van-form rules="rules" ref="bankForm">
                <van-field
                        input-align="right"
                        label-align="left"
                        maxlength="19"
                        size="14px"
                        placeholder="请输入银行卡号"
                        :rules="[{required: true, message: '银行账号不能为空', trigger: 'onBlur'}]"
                        :formatter="formatter"
                        v-model="userInfo.bankCardNumber"
                        right-icon="edit"
                />
              </van-form>
            </div>
          </div>
          <div style="padding: 0px 20px 0px 20px;color: red; text-align: right">
            注意：只能输入一类卡银行信息
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 43px">经办行：</div>
            <div class="right">
              <van-field
                      readonly
                      clickable
                      style="height: 35px"
                      v-model="manageBankName"
                      placeholder="请选择经办行"
                      :rules="[{ required: true, message: '必选',trigger:'onChange' }]"
                      :right-icon="manageBankIcon"
                      @click="showManageBank = true"
              />
            </div>
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 43px">开户行：</div>
            <div class="right">
              <van-field
                      readonly
                      clickable
                      style="height: 35px"
                      v-model="openBankName"
                      placeholder="请选择开户行"
                      :rules="[{ required: true, message: '必选',trigger:'onChange' }]"
                      :right-icon="openBankIcon"
                      @click="showOpenBank = true"
              />
            </div>
          </div>
          <div style="padding: 0px 20px 0px 20px;color: red; text-align: right;font-size: 13px;">
            只要经办行是中行，默认选择开户行是黄石东路支行就可以
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 43px">附件：</div>
            <div class="right">
              <van-uploader
                      :after-read="onRead"
                      accept=".jpg,.jepg,.png,.pdf,.zip,.rar,.7z"
                      v-model="fileList"
                      :max-count="6"
                      :max-size="'500 * 1024'"
                      @oversize="onOversize"
                      @delete="delImg"
              >
              </van-uploader>
            </div>
          </div>
          <div style="padding: 0px 20px 0px 20px;color: #ff0000; text-align: right;font-size: 13px;">
            {{this.bank_info_note}}
          </div>
        </template>
      </mobile-card>

      <mobile-card style="font-size: 14px">
        <template slot="title">
          <div class="charge-card-title">票据信息</div>
        </template>
        <template slot="content">
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 28px">票据抬头：</div>
            <div class="right">
              <van-field
                      input-align="right"
                      label-align="left"
                      size="14px"
                      placeholder="请输入票据抬头"
                      style="
                  padding: 0px;
                  margin: 0px;
                  height: 100%;
                  line-height: 28px;
                  padding-right: 5px;
                "
                      v-model="userInfo.ticketTitle"
                      right-icon="edit"
              />
            </div>
          </div>
          <div class="flex-form-info" style="height: auto">
            <div class="left" style="line-height: 28px">票据税号：</div>
            <div class="right">
              <van-field
                      input-align="right"
                      label-align="left"
                      size="14px"
                      placeholder="请输入票据税号"
                      style="
                  padding: 0px;
                  margin: 0px;
                  height: 100%;
                  line-height: 28px;
                  padding-right: 5px;
                "
                      v-model="userInfo.ticketTaxNumber"
                      right-icon="edit"
              />
            </div>
          </div>
        </template>
      </mobile-card>

      <div class="login-btn" style="padding: 10px 15px 10px 15px">
        <van-button block type="info" @click="save"> 保 存 </van-button>
      </div>
      <div class="login-btn" style="padding: 10px 15px 10px 15px">
        <van-button block @click="cancel"> 重 置 </van-button>
      </div>
      <div style="padding: 0px 20px 0px 20px; color: red; text-align: center">
        注意：该默认票据抬头仅对以后的收费生效，不会更改已经收费的抬头。
      </div>
    </div>
    <van-popup v-model="showOpenBank" position="bottom">
      <van-picker
              show-toolbar
              value-key="name"
              :columns="openBanks"
              @confirm="onOpenConfirm"
              @cancel="showOpenBank = false"/>
    </van-popup>
    <van-popup v-model="showManageBank" position="bottom">
      <van-picker
              show-toolbar
              value-key="name"
              :columns="manageBanks"
              @confirm="onManageConfirm"
              @cancel="showManageBank = false"/>
    </van-popup>
  </div>
</template>
<script>
  import axios from "axios"
  import MobileCard from "components/mobile-card/index";
  import apiUserPage from "@/api/user-page/index";
  import bankDrop from "@/api/bank_drop";
  import {
    removeToken,
    loadToken,
  } from '@/utils/cache'
  export default {
    name: "chargeCard",
    components: { MobileCard },
    data() {
      return {
        userInfo: {},
        bank_info_note: '请上传身份证、校园卡及银行卡扫描件(合并一个附件上传)，如果有疑问请联系36207034',
        showOpenBank:false,
        showManageBank: false,
        manageBankName:'',
        openBankName:'',
        openBanks:[],
        manageBanks:[],
        fileList:[],
        rules: {
          bankCardNumberRules: [{
            required: true,
            message: '银行账号不能为空',
            trigger: 'onBlur'
          }]
        },
        originUserInfo: {}
      };
    },
    watch: {},
    methods: {
      delImg (index) {
        // 删除指定下标的图片对象
        if (isNaN(index) || index >= this.fileList.length) {
          return false
        }
        this.fileList.splice(index, 1)
      },
      getUserInfo() {
        apiUserPage.userDetail().then((res) => {
          let d = res.data;
          if (d) {
            this.userInfo = d;
            this.title = d.userCode + "-" + d.userName;
            if (d.deptNames && d.deptNames.length > 0) {
              d.deptNames = d.deptNames[0];
            } else {
              d.deptNames = "";
            }
          } else {
            this.userInfo = {
              tele: "",
              email: "",
              ticketTitle: "",
              ticketTaxNumber: "",
            };
          }
          if (!this.userInfo.bankAccountName) {
            this.userInfo.bankAccountName = this.userInfo.userName
          }
					this.originUserInfo = JSON.parse(JSON.stringify(this.userInfo))
          this.getOpenBank();
          this.getManageBank();
        });
      },
      cancel() {
        this.getUserInfo();
      },
      formatter(value) {
        // 过滤输入的数字
        return value.replace(/[^\d]/g,'');
      },
      save() {
        let param = {
          tele: this.userInfo.tele,
          email: this.userInfo.email,
          ticketTitle: this.userInfo.ticketTitle,
          ticketTaxNumber: this.userInfo.ticketTaxNumber,
          bankAccountName: this.userInfo.bankAccountName,
          bankCardNumber: this.userInfo.bankCardNumber,
          manageBankCode: this.userInfo.manageBankCode,
          openBank: this.userInfo.openBank,
        };
        if((param.bankCardNumber||param.manageBankCode||param.openBank)
                &&!(param.bankCardNumber&&param.manageBankCode&&param.openBank)){
          this.$notify({
            message: "请填写完整的银行卡信息",
            type: 'warning'
          })
          return false
        }
				if (!(param.bankCardNumber && param.manageBankCode && param.openBank)) {
					param.manageBankCode = ''
					param.openBank = ''
				}
        // 修改了银行卡信息，附件必传
        if (!this.isEqual(this.originUserInfo.bankAccountName, param.bankAccountName)
          || !this.isEqual(this.originUserInfo.bankCardNumber, param.bankCardNumber)
          || !this.isEqual(this.originUserInfo.manageBankCode, param.manageBankCode)
          || !this.isEqual(this.originUserInfo.openBank, param.openBank)) {
          if(this.fileList && this.fileList.length){
            let fileIdArr = this.fileList.map(item => {
              return item.id
            })
            let fileIds = fileIdArr.join()
            param.fileIds = fileIds
          }
          if (!param.fileIds) {
            this.$notify({
              message: '请上传银行卡修改附件',
              type: 'warning'
            })
            return
          }
					param.needUpdateBank = true
        } else {
					param.needUpdateBank = false
        }
        if (param.ticketTaxNumber) {
          param.ticketTaxNumber = param.ticketTaxNumber.replace(/( )/g, '')
        }
        if (this.userInfo.bankCardNumber && this.userInfo.bankCardNumber.length<12) {
          this.$notify({
            message: "请输入正确12-19位纯数字的账号",
            type: 'warning'
          })
          return false
        }
        apiUserPage.update(param).then((res) => {
          let tips = '修改个人信息成功'
          if (param.needUpdateBank) {
            tips += '\n请耐心等待审核，审核通过后才会显示银行卡信息'
          }
          this.$notify({
            message: tips,
            type: "success",
            duration: 5000
          });
          this.fileList = []
          this.getUserInfo();
          this.$store.dispatch("mars/user/getUserInfo");
        });
      },
      onOversize(file){
        this.$notify({
          message: "请上传小于10M的图片",
          type: "warning",
        });
      },
      onRead(file) {
        const data = new FormData()
        if(file.constructor!=Array){
          data.append("dataFile",file.file)
        }else{
          file.forEach(element=>{
            data.append("dataFile",element.file)
          })
        }
        let url = this.wConfig.VUE_APP_BASE_API+'/client/combo/upload'
        axios.post(url,data,{headers:{'token':loadToken()}}).then(res=>{
           file.id = res.data.data.id
        }).catch(error=>{

        })
      },
      getManageBank() {
        bankDrop.manageBankDrop().then(({data}) => {
          this.manageBanks = data || []
          if(data){
            let defaultManageBank = data.filter(f=>f.code==this.userInfo.manageBankCode)
            if(defaultManageBank.length>0){
              this.manageBankName = defaultManageBank[0].name
            }else{
              this.manageBankName = '';
            }
          }
        })
      },
      getOpenBank() {
        bankDrop.openBankDrop().then(({data}) => {
          this.openBanks = data || []
          if (data) {
            let defaultOpenBank =data.filter(f=>f.id==this.userInfo.openBank)
            if(defaultOpenBank.length>0){
              this.openBankName = defaultOpenBank[0].name
            }else{
              this.openBankName = '';
            }
          }
        })

      },
      onOpenConfirm(item) {
        this.openBankName = item.name
        this.userInfo.openBank = item.id
        this.showOpenBank = false
      },
      onManageConfirm(item) {
        this.manageBankName = item.name
        this.userInfo.manageBankCode = item.code
        this.showManageBank = false
      },
			isEqual(str1, str2) {
				if (str1 && str2) {
					return str1 === str2
				} else if (!str1 && !str2) {
					return true
				}
				return false
			}
    },
    mounted() {},
    created() {
      this.getUserInfo();
    },
    watch: {
      // 如果路由发生变化，再次执行该方法
      "$route": "getUserInfo"
    },
    computed: {
      openBankIcon() {
        return this.showOpenBank ? 'arrow-up' : 'arrow-down'
      },
      manageBankIcon() {
        return this.showManageBank ? 'arrow-up' : 'arrow-down'
      },
    }
  };
</script>
<style lang="scss" scoped>
  .charge-card-title {
    /*font-size: 16px;*/
    /*font-weight: bold;*/
    color: #005423;
    background: #e9e9e9;

    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 5px 5px 0 0;
  }

  .charge-card {
    width: 90vw;
    margin: 2vh auto;
    background: #ffffff;
    border-radius: 5px;

    .card-info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      // padding: 2vw 4vw;
      padding: 10px 16px;

      .left {
        flex: auto;
        text-align: left;
        vertical-align: center;
      }

      .right {
        flex: auto;
        text-align: right;
      }
    }
  }

  .input-border {
    /deep/ .van-field__body {
      border: 1px solid #005423;
      border-radius: 5px;
      padding-right: 5px;
      padding-left: 5px;
    }
  }

  .text-field {
    padding-top: 0px;
    padding-right: 0px;
  }

  .link {
    text-decoration: underline;
    color: #005423;
  }

  /deep/ .van-checkbox__icon .van-icon {
    border-color: #ababab;
  }

  /deep/ .van-checkbox__label {
    color: #005423;
  }

  /deep/ .van-field {
    font-size: 14px;
  }

  /deep/ .van-field__label {
    text-align: left;
  }

  /deep/ .flex-form-info {
    height: 38px;
    padding-top: 0px;
  }

  /deep/ .van-dropdown-item__content {
    width: 90%;
    left: 5%;
  }

  /deep/ .van-dropdown-menu__title {
    font-size: 14px;
  }
</style>
